import { useEffect } from 'react';

export function useUnsavedChangesPrompt(shouldPrompt: boolean) {
  useEffect(() => {
    if (!shouldPrompt) {
      return;
    }

    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault();
    };

    globalThis.addEventListener('beforeunload', handler);

    // eslint-disable-next-line consistent-return
    return () => globalThis.removeEventListener('beforeunload', handler);
  }, [shouldPrompt]);
}
